import { useAuth } from "@/hooks/use-auth"
import { AUTH_DISABLED } from "@/authConfig"

export function useAuthReady(): boolean {
  const { isAuthenticated, isLoading } = useAuth()

  if (AUTH_DISABLED) {
    return true
  }

  return !isLoading && isAuthenticated
}
